import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AmexOfferModalComponent } from '../../../components/amex-offer-modal/amex-offer-modal.component';

@Component({
	selector: 'app-amex-offer-button',
	templateUrl: './amex-offer-button.component.html',
	styleUrl: './amex-offer-button.component.scss',
})
export class AmexOfferButtonComponent {
	private readonly modalCtrl = inject(ModalController);

	openInfo(event: Event) {
		event.stopPropagation();
		AmexOfferModalComponent.show(this.modalCtrl);
	}
}
